
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { themeVariablesCSS, baseStylesCSS } from './styles/global.stylex';

// Inject global StyleX theme variables and base styles
const styleElement = document.createElement('style');
styleElement.textContent = themeVariablesCSS + '\n' + baseStylesCSS;
document.head.appendChild(styleElement);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>,
);
